import { PawPrint } from "lucide-react";

export const KiddeeSeal = ({ className = "", testId }) => (
  <span
    data-testid={testId}
    title="Kiddee approved: one of her favorites"
    className={`seal-pop inline-flex flex-col items-center justify-center w-16 h-16 rounded-full bg-[#E06D44] text-white text-center shadow-lg ring-4 ring-white/90 rotate-[-12deg] ${className}`}
  >
    <PawPrint size={14} />
    <span className="text-[8px] font-extrabold uppercase leading-[1.05] tracking-wider mt-0.5">Kiddee<br />approved</span>
  </span>
);
